import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserEntitlements } from '../models/UserEntitlements';
import { UserpermissionsGatewayService } from 'src/app/services/userpermissions-gateway.service';

@Injectable({
  providedIn: 'root'
})
export class EntitlementsProviderService {
  products: string[] = ['SCF', 'AR', 'PTS'];
  userIdArray: number[] = [];
  private readonly rootUri: string = 'api/userEntitlements';

  showPublishOptionSource: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showPublishOption = this.showPublishOptionSource.asObservable();

  constructor(
    private permissionsGatewayService: UserpermissionsGatewayService)
  { }

  updateUserIdArray(id: number) {
    if (!this.userIdArray.includes(id)) {
      this.userIdArray.push(id);
    }
    this.showPublishOptionSource.next(true);
  }

  getUserEntitlements(platformCode: string): Observable<UserEntitlements[]> {
    return this.permissionsGatewayService.get<UserEntitlements[]>(`api/UserEntitlements/${platformCode}`);
  }
}

export class SynchronizationResult {
  constructor(productCode: string, isError: boolean) {
    this.productCode = productCode;
    this.isError = isError;
  }

  public productCode: string;
  public isError: boolean;
}
